import styled from '@emotion/styled';
import { Tag } from 'antd';
import { theme } from 'configs/styled';
import React from 'react';

export const StatusTag = styled(Tag)`
  border-radius: ${theme.elementSize.tagBorderRadius};
  text-align: 'center';
  font-family: ${theme.fonts.NotoSansTh};
  font-style: normal;
  font-weight: ${theme.fontWeight.regular};
  font-size: ${theme.fontSize.xs};
  line-height: '22px';
  border: 0;
`;

const documentsReviewStatuses = [
  {
    name: 'ส่งข้อมูล',
    color: theme.palettes.documentsStatus.draft,
    textColor: theme.palettes.documentsStatusText.draft,
  },
  {
    name: 'กำลังตรวจสอบ',
    color: theme.palettes.documentsStatus.waitingApprove,
    textColor: theme.palettes.documentsStatusText.waitingApprove,
  },
  {
    name: 'อนุมัติแล้ว',
    color: theme.palettes.documentsStatus.approved,
    textColor: theme.palettes.documentsStatusText.approved,
  },
  {
    name: 'เอกสารไม่ถูกต้อง',
    color: theme.palettes.documentsStatus.rejected,
    textColor: theme.palettes.documentsStatusText.rejected,
  },
];

function getStatus(name = '') {
  return documentsReviewStatuses.find(status => status.name === name.trim());
}

interface DocumentsReviewStatusProps {
  statusName?: string;
}

const DocumentsReviewStatus: React.FC<DocumentsReviewStatusProps> = props => {
  const { statusName } = props;
  const status = getStatus(statusName);

  return status ? (
    <>
      <StatusTag
        style={{
          color: status.textColor,
          backgroundColor: status.color,
        }}
      >
        {status.name}
      </StatusTag>
    </>
  ) : (
    <></>
  );
};

DocumentsReviewStatus.defaultProps = {
  statusName: '',
};

export default DocumentsReviewStatus;
